import React, { useContext, useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import classes from "./Navbar.module.scss";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import {  MenuItem, Skeleton,Select } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { DDD, E2Data } from "../../lib/ddd/ddd";
import { useQuery } from "@tanstack/react-query";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import { useTranslation } from 'react-i18next';
import Button from "../UI/Button";
import { useForm } from "react-hook-form";
import WarningTooltip from "../profileComponents/WarningTooltip";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ErrorAlert from "../UI/ErrorAlert";
import SuccessAlert from "../UI/SuccessAlert";
import { ThreeDots } from "react-loader-spinner";

import PhoneIcon from '@mui/icons-material/Phone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import BusinessIcon from '@mui/icons-material/Business';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import FlagIcon from '@mui/icons-material/Flag';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PPAIcon from "../../assets/ppa-icon.png";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonIcon from '@mui/icons-material/Person';
import TagIcon from '@mui/icons-material/Tag';
import { ReactComponent as VatIcon } from "../../assets/vat-icon2.svg";
import { ReactComponent as TaxIcon } from "../../assets/tax-icon.svg";
import { ReactComponent as BdgIcon } from "../../assets/bgd-icon.svg";
import { ReactComponent as RegisterIcon } from "../../assets/register-icon.svg";
import ButtonLink from "../UI/ButtonLink";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("Countries");
e2Data.format="Full";
e2Data.filter = "EinvoicesOrder <> null";
e2Data.orderBy = "EinvoicesOrder asc, CountryNameOriginal asc";
e2Data.take = null;

const e2CustomerObject = new E2Data("EU_CustomerObject");
e2CustomerObject.format="Full";
e2CustomerObject.orderBy = "OrderInObject asc";
e2CustomerObject.take = null;
e2CustomerObject.filter = "Valid = true AND ForCompany = true";

const iconStyle = {fontSize:"1.2rem"}
const defaultone ={defaultValues:{
    CustomerName : "1243",
    CustomerEmail : "aaaa@aaa.com",
    CustomerVatNum : "1234",
    CustomerTaxNum : "6545985",
    CustomerPhone : "gfgfg",
    BankAccountNum : "gfhdret",
    CultureCode : "sl-SI",
    CustomerAddress : "sl-SI",
    CustomerCityName : "sl-SI",
    CustomerPostCode : "sl-SI",
    CustomerCountryCode : "FR",
}}
/*const customerFields1 = {
    "CultureCode":{
        group : "basic",
        label : "Culture",
        type : "select",
    },
    "BankAccountNum": {
        type : "text",
        label : "Bank account number",
        placeholder : "Enter account number",
        subType: <TagIcon style={iconStyle}/>,
        group : "basic",
    },
    "CustomerName": {
        type : "text",
        label : "Name",
        placeholder : "Enter customer name",
        subType: <PermIdentityIcon style={iconStyle}/>,
        //validation : {required:"Customer name is required"},
        group : "basic",
    },
    "CustomerPhone" :{
        type : "text",
        label : "Phone number",
        placeholder : "+12345568901",
        subType : <PhoneIcon style={iconStyle}/>,
        group : "basic",
    },
    "CustomerEmail" : {
        type : "text",
        label : "Email",
        placeholder: "example@domain.com",
        subType : <AlternateEmailIcon style={iconStyle}/>,
        validation : {
            required: "Email Address is required",
            pattern: {
            value: /^\S+@\S+$/i,
            message: "Invalid email address",
            }},
        group : "basic",
    },
    "CustomerTaxNum" : {
        label : "Tax number",
        placeholder: "Enter tax number",
        type : "text",
        //validation : {required: "TAX number is required"},
        subType : <TaxIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerAddress" : {
        type : "text",
        label : "Address",
        placeholder: "Enter address",
        subType : <BusinessIcon style={iconStyle}/>,
        group : "address",
    },
    "CustomerCityName" : {
        type : "text",
        label : "City",
        placeholder: "Enter city",
        subType : <LocationCityIcon style={iconStyle}/>,
        group : "address",
    },
    "CustomerPostCode" : {
        type : "text",
        label : "Post code",
        placeholder: "Enter postcode",
        subType : <LocalPostOfficeIcon style={iconStyle}/>,
        group : "address",
    },
    "CustomerCountryCode" : {
        type : "select",
        label : "Country",
        placeholder: "Select country",
        subType : <FlagIcon style={iconStyle}/>,
        //validation : {required:"Customer country is required"},
        group : "address",
    },
    "CustomerVatNum" : {
        label : "VAT number",
        placeholder: "Enter value added tax number",
        type : "text",
        //validation : {required: "VAT number is required"},
        subType : <VatIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerBudgetNum" : {
        type : "text",
        label : "Budget number",
        placeholder: "Enter budget number",
        tooltip : "Budget identification number of direct and indirect users of the state budget",
        subType: <img  src={PPAIcon} alt="budgetImg" style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerRegNum" : {
        type : "text",
        label : "Registration number",
        placeholder: "Enter registration number",
        tooltip : "An identifier issued by an official registrar that identifies the customer as a legal entity or person",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerRelation" : {
        type : "select",
        label : "Customer relation",
        placeholder: "Enter customer relation",
        tooltip : "Select what relationship they will have with its customers",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
        validValues: [{value: null, desc:null}, 
                    {value:"AdminByCustomer", desc : "Customer administration"},
                    {value:"SupportByDDD", desc : "Customer administration, DDD support"},
                    {value:"EIOL", desc : "EIOL"}]
    },
    "ClientType" : {
        type : "select",
        label : "Client type",
        placeholder: "Enter client type",
        tooltip : "Is this customer an accounting service?",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
        validValues: [{value: null, desc:null}, 
                    {value:"AccService", desc : "Accounting service"},]
    },
    "CustomerLegalStructure" : {
        type : "select",
        label : "Legal structure",
        placeholder: "Select legal structure",
        tooltip : "",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
        validValues: [{value: null, desc:null}, 
                    {value:"Subsidary", desc : "Subsidary"},
                    {value:"Headquater", desc : "Headquater"},
                    {value:"OnlyVatRegistration", desc : "Only VAT Registration"},]
    },
}*/

const CreateOrgModal = ({onHiddenChange, onAddNewCompany, ...props}) => {
    const { clientType, customerRelation, aboutOrgId, mainOrgId, sessionInfo } = useContext(OrgIdContext);
    const [showUser, setShowUser] = useState(true);
    const [countriesList, setCountriesList] = useState([]);
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState();
    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [cultures, setCultures] = useState([]);
    const [error, setError] = useState();
    const [customerFields, setCustomerFields] =  useState({});
    const { t } = useTranslation();

    const customerFields1 = {
        "CultureCode":{
            group : "basic",
            label : t("Culture"),
            type : "select",
        },
        "BankAccountNum": {
            type : "text",
            label : t("Bank account number"),
            placeholder : t("Enter account number"),
            subType: <TagIcon style={iconStyle}/>,
            group : "basic",
        },
        "CustomerName": {
            type : "text",
            label : t("Name"),
            placeholder : t("Enter customer name"),
            subType: <PermIdentityIcon style={iconStyle}/>,
            //validation : {required:"Customer name is required"},
            group : "basic",
        },
        "CustomerPhone" :{
            type : "text",
            label : t("Phone number"),
            placeholder : "+12345568901",
            subType : <PhoneIcon style={iconStyle}/>,
            group : "basic",
        },
        "CustomerEmail" : {
            type : "text",
            label : t("Email"),
            placeholder: "example@domain.com",
            subType : <AlternateEmailIcon style={iconStyle}/>,
            validation : {
                required: t("Email Address is required"),
                pattern: {
                value: /^\S+@\S+$/i,
                message: t("Invalid email address"),
                }},
            group : "basic",
        },
        "CustomerTaxNum" : {
            label : t("Tax number"),
            placeholder: t("Enter tax number"),
            type : "text",
            //validation : {required: "TAX number is required"},
            subType : <TaxIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerAddress" : {
            type : "text",
            label : t("Address"),
            placeholder: t("Enter address"),
            subType : <BusinessIcon style={iconStyle}/>,
            group : "address",
        },
        "CustomerCityName" : {
            type : "text",
            label : t("City"),
            placeholder: t("Enter city"),
            subType : <LocationCityIcon style={iconStyle}/>,
            group : "address",
        },
        "CustomerPostCode" : {
            type : "text",
            label : t("Post code"),
            placeholder: t("Enter postcode"),
            subType : <LocalPostOfficeIcon style={iconStyle}/>,
            group : "address",
        },
        "CustomerCountryCode" : {
            type : "select",
            label : t("Country"),
            placeholder: t("Select country"),
            subType : <FlagIcon style={iconStyle}/>,
            //validation : {required:"Customer country is required"},
            group : "address",
        },
        "CustomerVatNum" : {
            label : t("VAT number"),
            placeholder: t("Enter value added tax number"),
            type : "text",
            //validation : {required: "VAT number is required"},
            subType : <VatIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerBudgetNum" : {
            type : "text",
            label : t("Budget number"),
            placeholder: t("Enter budget number"),
            tooltip : t("Budget identification number of direct and indirect users of the state budget"),
            subType: <img  src={PPAIcon} alt="budgetImg" style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerRegNum" : {
            type : "text",
            label : t("Registration number"),
            placeholder: t("Enter registration number"),
            tooltip : t("An identifier issued by an official registrar that identifies the customer as a legal entity or person"),
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerRelation" : {
            type : "select",
            label : t("Customer relation"),
            placeholder: t("Enter customer relation"),
            tooltip : t("Select what relationship they will have with its customers"),
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
            validValues: [{value: null, desc:null}, 
                        {value:"AdminByCustomer", desc : "Customer administration"},
                        {value:"SupportByDDD", desc : "Customer administration, DDD support"},
                        {value:"EIOL", desc : "EIOL"}]
        },
        "ClientType" : {
            type : "select",
            label : t("Client type"),
            placeholder: t("Enter client type"),
            tooltip : t("Is this customer an accounting service?"),
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
            validValues: [{value: null, desc:null}, 
                        {value:"AccService", desc : "Accounting service"},]
        },
        "CustomerLegalStructure" : {
            type : "select",
            label : t("Legal structure"),
            placeholder: t("Select legal structure"),
            tooltip : "",
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
            validValues: [{value: null, desc:null}, 
                        {value:"Subsidary", desc : t("Subsidary")},
                        {value:"Headquarters", desc : t("Headquarters")},
                        {value:"BranchOffice", desc : t("Branch Office")},]
        },
    }

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm(/*defaultone*/);

    const {isPending : isDataPending, data : countriesData} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
        staleTime: Infinity
    })

    const {isPending : customerObjDataPending, data : customerObjData} = useQuery({
        queryKey: ["EU_CustomerObject",e2CustomerObject.GetParamsObject()],
        queryFn: () => e2CustomerObject.GetData(),
        //queryFn: () => e2CustomerObject.Delay(),
        staleTime: Infinity
    })

    const {isPending : cultureDataPending, data : cultureData} = useQuery({
        queryKey: ["Auth.GetSupportedCultures"],
        queryFn: () => ddd.Rpc_ExecuteMethod("Auth.GetSupportedCultures"),
        staleTime: Infinity
    })

    useEffect(() => {
        if(customerObjDataPending || !customerObjData || cultureDataPending || !cultureData)
          return;
    
        setIsLoading(false);
        const data = customerObjData.result?.data;

        if(!data)
            return setError("Unable to load data");
        if(!cultureData)
            return setError("Unable to load cultures");

        setRows(data);
        setCultures(cultureData.result);
        const skip = ["MyAccessAsAdmin", "MyAccessAsAdminId", "FromDomain", "AdminEmail", "AdminLastName", "AdminName"];

        let obj = {};
        data.forEach(field => {
            if(skip.indexOf(field.NameInObject) > -1)
                return;
            obj[field.NameInObject] =  customerFields1[field.NameInObject] ? {...customerFields1[field.NameInObject]} : {group :"basic"};
            obj[field.NameInObject].validation = getValidation(field);
            obj[field.NameInObject].tooltip = getTooltip(field);
        })
        
        setCustomerFields(obj);
    },[customerObjDataPending, customerObjData, cultureDataPending, cultureData]);

    useEffect(() => {
        if(!isDataPending){
            setCountriesList(countriesData.result?.data);
        }
    }, [isDataPending])

    const getValidation = (fieldInfo) =>{
        if(fieldInfo.MandatoryForCompany)
            return {required: t("This field is required")};
    }

    const getTooltip = (fieldInfo) =>{
        if(fieldInfo.CompanyDesc)
            return fieldInfo.CompanyDesc;
        return null;
    }

    const getCustomerHelper = (fieldName) =>{
        if(!customerFields[fieldName].tooltip)
            return;
        return(
            <OverlayTrigger placement="top" overlay={<Tooltip>{customerFields[fieldName].tooltip}</Tooltip>}>
                <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
        )
    }

    const getErrorMessage = (fieldName) => {
        if(errors[fieldName]){
            return (
                <WarningTooltip text={errors[fieldName].message}/>
            )
        }
    }

    const getCustomerElement = (fieldsObj, fieldName, validation) =>{
        if(fieldsObj[fieldName].subType){
            return(<>
            <div key={"inputEl"+fieldName} className="input-group" style={{flexWrap:"nowrap"}}>
                {getInputElement(
                    fieldName, 
                    fieldsObj[fieldName].type,
                    fieldsObj[fieldName].validation || validation || {},
                    {
                        placeholder: fieldsObj[fieldName].placeholder || ""
                    }
                    )}
                {getSubtypeElement(fieldsObj[fieldName].subType)}
            </div>
            </>)
        }else{
            return getInputElement(fieldName, fieldsObj[fieldName].type, fieldsObj[fieldName].validation || validation || {});
        }
    }

    const getInputElement = (name, type, validation={}, props ) =>{
        if(name==="CustomerCountryCode")
            return getCountriesSelect(name, validation);
        if(name==="CultureCode")
            return getCulturesSelect(name, validation);
        switch(type){
            case "select":
                return(
                    <select
                        {...register(name, validation)}
                        placeholder={customerFields[name].placeholder}
                        style={errors[name] ? {maxWidth:"none",outlineColor:"red"} : {maxWidth:"none"}}
                        >
                            {/* <option key="empty" value={""}>{customerFields[name].placeholder}</option> */}
                            {customerFields[name].validValues && customerFields[name].validValues.map((data, i)=>{
                                return(
                                <option value={data.value} key={i}>
                                    {data["desc"]}
                                </option>)
                            })}
                        </select>
                )
            default:
                return (
                    <input
                    type="text"
                    style={errors[name] ? {outlineColor:"red"} :{}}
                    {...register(name, validation)}
                    {...props}
                    />
                )
        }
    }
    const getCulturesSelect = (name, validation={}) =>{
        return(
            <Select
            className={classes["mui-select"]}
            style={errors[name] ? {padding:"0px", display:"block", borderRadius:"10px", border:"1px solid red"} : {padding:"0px", display:"block", borderRadius:"10px", border:"1px solid #005683"}}
            sx={{ padding : "0px", boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }, "& .MuiSelect-select": {paddingRight:"0px"} }}
            {...register(name, validation)}>
                {cultures.map((data, i)=>{
                    return(
                        <MenuItem value={data.Culture} key={i}>
                            <img style={{marginLeft:".5rem"}} alt="" src={(process.env.REACT_APP_ORIGIN || window.location.origin)+"/"+data["FlagIconUrl4x3"]} width="25"/>
                            <span style={{paddingLeft:"1rem"}}>{data["Culture"]}</span>
                        </MenuItem>)
                })}
            </Select>
        )
    }
    const getCountriesSelect = (name, validation={}) =>{
        return (
            <select
            {...register(name, validation)}
            placeholder="Select a country"
            style={errors[name] ? {maxWidth:"none",outlineColor:"red"} : {maxWidth:"none"}}
            >
                <option key="empty" value={""}>{t("Select a country...")}</option>
                {countriesList.map((data, i)=>{
                    return(
                    <option value={data.CountryCodeISOC2} key={i}>
                        {data["CountryNameOriginal"]}
                    </option>)
                })}
            </select>
        )
    }

    const getSubtypeElement = (subType) =>{
        switch(subType){
            default:
                return(
                    <span className="input-group-text" style={{border:"none", outline:"1.5px solid #005683", backgroundColor:"#fbfbfb"}}>
                        {subType}
                    </span>
                )
        }
    }

    const createUserSubmit = (data) =>{
        data.MyAccessAsAdmin = true;
        data.MyAccessAsAdminId = sessionInfo?.User?.Id;
        data.FromDomain = window.location.hostname;

        if(saving)
            return;
        setSaving(true);
        setSaveError(null);
        setSuccess(null);

        ddd.Rpc_ExecuteExtension("EUeInvoices.DDDI_AddCompany", data).then(res =>{
            setSaving(false);

            if(!res?.result)
                return setSaveError("And unknown error occured. Please contact administrator.")
            
            if(res?.result?.Status === "Error")
                return setSaveError(res.result.Reason || "Server error occured. Please contact administrator.");

            if(res?.result?.Status === "OK"){
                let conKey = res.result.Result;
                if(clientType === ClientTypes.ISV){
                    if(onAddNewCompany) onAddNewCompany(data, conKey);
                    return setSuccess(t(`Success! A company with`)+` "${conKey}" `+t(`connection key has been created. It will take a few minuts for the company to appear on your list`))
                }
                if(onAddNewCompany) onAddNewCompany(data, conKey);
                return setSuccess(t(`Success! A new company has been created. It will take a few minuts for the company to appear on your list.`))
            }

            return setSaveError("An unkown error has occured. Please contact administrator.")
        });
    }

    return ( 
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          {...props}
        >
          <Modal.Header className={classes.modalHeader}>
            <div className='w-100 d-flex '>
                <div>
                  <CorporateFareIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/>
                  <span className={classes.modalTitleText}>{t("Create organization")}</span>
                </div>
                <div className="ms-auto">
                  <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}}  onClick={props.onHide} />
                </div>
              </div>
          </Modal.Header>
          <Modal.Body className={classes["modalBody"]}>
            <div className="fs-7 mb-2">
                {t("This form is intended for registering subsidiaries and branch offices of your company, not for registering your customers. ")}
                {t("To register a customer click here")}
                <ButtonLink href="/clients" className="px-2 py-1 ms-2" onClick={props.onHide}>
                    {t("Register a customer")} <ArrowForwardIcon style={{fontSize:"0.9rem"}}/>
                </ButtonLink>
            </div>
            <form className={classes["input-container"]} onSubmit={handleSubmit(createUserSubmit)}>
                {Object.keys(customerFields).map((fieldName, i) => {
                    if(customerFields[fieldName].group !== "basic")
                        return null;
                    return(
                    <fieldset key={"fset"+fieldName} className={classes["user-fieldset"]}>
                        <label>
                            {customerFields[fieldName].label || fieldName}
                            {customerFields[fieldName].validation?.required && <span style={{color:"red"}}>*</span>}
                            {getCustomerHelper(fieldName)}
                            {getErrorMessage(fieldName)}
                        </label>
                        {getCustomerElement(customerFields,fieldName)}
                    </fieldset>
                    )
                })}
                 <p className={classes["divider-text"]}>
                    <span className={classes["bg-light"]}>
                        <BusinessIcon style={{fontSize:"2rem"}}/>
                    </span>
                </p>
                {Object.keys(customerFields).map((fieldName, i) => {
                    if(customerFields[fieldName].group !== "address")
                        return null;
                    return(
                    <fieldset key={"fset"+fieldName} className={classes["user-fieldset"]}>
                        <label>
                            {customerFields[fieldName].label || fieldName}
                            {customerFields[fieldName].validation?.required && <span style={{color:"red"}}>*</span>}
                            {getErrorMessage(fieldName)}
                        </label>
                        {getCustomerElement(customerFields,fieldName)}
                    </fieldset>
                    )
                })}
                <div className="text-center pt-3">
                    {saving  && <ThreeDots height="50" width="50" color="#005683" wrapperStyle={{justifyContent:"center"}}/>}
                    {saveError && <ErrorAlert text = {saveError} style={{marginBottom:"1rem"}}/>}
                    {success && <SuccessAlert text = {success} style={{marginBottom:"1rem"}}/>}
                    <Button type="submit" className="px-5 py-1 ms-3" disabled ={saving}>
                        <PersonAddIcon style={{marginRight:"1rem"}}/>
                        {t("Add company")}
                    </Button>
                </div>
            </form>
          </Modal.Body>
        </Modal>
      );
};

export default CreateOrgModal;